import { useEffect, useState } from "react";
import { Card, CardBody, Tooltip } from "@material-tailwind/react";
import { useLocation, useNavigate } from "react-router-dom";
import { PlusIcon, ArrowRightIcon } from "@heroicons/react/24/solid";
import "./HomePage.module.css";
import { CardSkeleton } from "../../utils/CardSkeleton";
import { checkUser, getFiles, getId } from "../../api/axiosInstanceApi";

type Thought = {
  filename: string;
  timestamp: string;
  query: string;
  response: string;
  citations: string[];
};

const ThoughtProcess = () => {
  const [thoughts, setThoughts] = useState<Thought[]>([]);
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [checkThoughtsFolderNotExist] = useState(false);
  const navigate = useNavigate();

  const handleSeeMoreClick = () => {
    navigate(`interactions`, { state: { thoughts } });
  };

  useEffect(() => {
    async function fetchThoughts() {
      try {
        const check_user_dir = await checkUser();
        const checkUserDirExist = check_user_dir.data;
        if (checkUserDirExist.exists) {
          const thoughtsFilesResponse = await getFiles();
          const filesData = thoughtsFilesResponse.data;
          if (filesData.error) {
            setIsLoading(false);
            return;
          }
          setThoughts(filesData);
          // filesData.sort((a: any, b: any) => {
          //   const timestampA = Number(a.slice(0, -4)); // Remove '.txt' and convert to number
          //   const timestampB = Number(b.slice(0, -4)); // Remove '.txt' and convert to number
          //   return timestampB - timestampA; // Sort in descending order (most recent first)
          // });

          // const fetchedThoughts: Thought[] = [];
          // let numberOfFileNeedToLoad = 3;
          // for (
          //   let i = 0;
          //   i < Math.min(filesData.length, numberOfFileNeedToLoad);
          //   i++
          // ) {
          //   try {
          //     const historyResponse = await getFileChats(
          //       filesData[i].substring(0, filesData[i].lastIndexOf("."))
          //     );
          //     const historyData = historyResponse.data.conversation;
          //     const latestThought = historyData[0];

          //     latestThought["filename"] = filesData[i].substring(
          //       0,
          //       filesData[i].lastIndexOf(".")
          //     );
          //     fetchedThoughts.push(latestThought);
          //   } catch (error) {
          //     numberOfFileNeedToLoad++;
          //     console.error(`Failed to fetch thought data `, error);
          //   }
          // }

          // setThoughts(fetchedThoughts);
        }
        setIsLoading(false);
      } catch (error) {
        setError(true);
        console.error(`Failed to fetch thought files `, error);
      }
    }

    fetchThoughts();
  }, []);

  const openSpecificThoughtClick = (thought: Thought) => {
    navigate(`interaction/${thought.filename}`, {
      state: { from: "individual" }
    });
  };
  const fetchIdAndNavigate = async () => {
    try {
      const idResponse = await getId();
      const id = idResponse.data;

      navigate(`interaction/${id.Id}`, { state: { from: "new" } });
    } catch (error) {
      console.error("Failed to fetch ID and navigate", error);
    }
  };
  const clickToCreateNewThought = () => {
    fetchIdAndNavigate();
  };

  if (checkThoughtsFolderNotExist) {
    return (
      <>
        <div className="grid grid-cols-3 gap-3 w-full min-w-96">
          <Card onClick={clickToCreateNewThought} className="hover:cursor-pointer pb-4 h-44 min-w-32 card_bg_color">
            <CardBody className="p-2 h-screen flex items-center justify-center">
              <PlusIcon className="h-20 w-20 text-sky-400 " />
            </CardBody>
          </Card>
        </div>
        <div className=" flex items-center justify-center  card_bg_color ">
          <div className="h-12 w-12"></div>
        </div>
      </>
    );
  }
  if (isLoading && error === false) {
    return (
      <div className="w-[89vw]">
        <CardSkeleton></CardSkeleton>
      </div>
    );
  }

  return (
    <>
      <div className="grid sm:grid-cols-3 gap-3  w-full ">
        <Card onClick={clickToCreateNewThought} className="hover:cursor-pointer pb-4 h-44 min-w-32 card_bg_color">
          <CardBody className="p-2 h-screen flex items-center justify-center">
            <PlusIcon className="h-20 w-20 text-sky-400" />
          </CardBody>
          <div className="text-center flex justify-center text-white">
            <span className="inline-block card_text_color text-sm"> Click to start a new interaction.</span>
          </div>
        </Card>
        {thoughts.slice(0, 2).map((thought, index) => (
          <Card
            key={index}
            onClick={() => openSpecificThoughtClick(thought)}
            className="hover:cursor-pointer pb-4 h-44 overflow-auto min-w-32 card_bg_color  card_text_color"
          >
            <CardBody className="p-2">{thought.query}</CardBody>
          </Card>
        ))}
      </div>
      <div className="flex sm:hidden justify-center p-5">
        <button className=" hover:cursor-pointer text-white text-sm " onClick={handleSeeMoreClick}>
          View More
        </button>
      </div>
      <div className="hidden sm:flex items-center justify-center   ">
        {thoughts.length > 2 ? (
          <div className="flex items-center justify-center hover:cursor-pointer">
            <Tooltip content="View More" placement="top-end" className="text-white bg-sky-800 font-bold p-2">
              <button onClick={handleSeeMoreClick} className="arrowForMore card_bg_color">
                <ArrowRightIcon className=" arrow-icon h-6 w-6 text-sky-400 " />
              </button>
            </Tooltip>
          </div>
        ) : (
          <div className="h-12 w-12"></div>
        )}
      </div>
    </>
  );
};

const HomePage = () => {
  const location = useLocation();
  const [isMaintenanceTrue, setIsMaintenanceTrue] = useState(false);
  const [maintenanceObject, setMaintenanceObject] = useState({
    date: "",
    status: "",
    time: ""
  });

  useEffect(() => {
    if (location.state && location.state.maintenance) {
      const status = location.state.maintenance.status;
      if (status === "True" || status === "true") {
        setMaintenanceObject(location.state.maintenance);
        setIsMaintenanceTrue(true);
      } else {
        setIsMaintenanceTrue(false);
        setMaintenanceObject({
          date: "",
          status: "",
          time: ""
        });
      }
    }
  }, [location.state]);

  return (
    <div className="relative ">
      {/* Background Content */}
      <div className=" inset-0 flex flex-col items-start ">
        <div className="my-3 font-bold heading_text_color">Interaction</div>
        <div className="sm:flex gap-4 w-full">
          <ThoughtProcess />
        </div>
      </div>
      {isMaintenanceTrue && (
        <div className="fixed inset-0 flex items-center justify-center  z-50">
          <dialog open className="w-5/12 shadow-lg z-50 p-3 border rounded-xl bg-white">
            <div className="overflow-auto">
              <div className="mb-3 flex justify-center">
                <h2 className="text-xl text-red-600 mb-2">
                  <span className="font-bold">NOTICE:</span> Scheduled Maintenance Alert
                </h2>
              </div>
              <div className="space-y-2">
                <div className="flex gap-2">
                  <span className="font-bold">Maintenance Date:</span>
                  <span>{maintenanceObject.date}</span>
                </div>
                <div className=" flex gap-2">
                  <span className="font-bold">Maintenance Window:</span>
                  <span>{maintenanceObject.time}</span>
                </div>
              </div>
            </div>
            <div className="flex justify-center pt-3">
              <button className="bg-slate-700 text-white rounded-md px-2 py-1" onClick={() => setIsMaintenanceTrue(false)}>
                OK
              </button>
            </div>
          </dialog>
        </div>
      )}
    </div>
  );
};

export default HomePage;
